import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { clsx } from '../../../utils/helper'

import IconSearch from '../../../assets/icons/IconSearch'
import WrapIcon from '../../elements/WrapIcon'
import IconClose from '../../../assets/icons/IconClose'
import { getFullFileUrl } from '../../../utils/formatData'

const MenuDesktop = ({
    displayGroup,
    groups,
    handleSetDisplayGroup,
    setSearchValue,
    logoPath,
}) => {
    const sliderRef = useRef()
    const containerSliderRef = useRef()
    const [searchOpen, setSearchOpen] = useState(false)
    const [localValue, setLocalValue] = useState('')
    const indexGroup = groups.findIndex(g => g.id === displayGroup)
    const [isReachEnd, setIsReachEnd] = useState(false)

    const handleCloseSearch = () => {
        setSearchOpen(false)
        setLocalValue('')
    }

    const handleNext = () => {
        sliderRef.current && sliderRef.current.slideNext(300)
    }

    useEffect(() => {
        sliderRef.current &&
            !sliderRef.current.destroyed &&
            sliderRef.current.slideTo(indexGroup, 300, false)
    }, [displayGroup])

    useEffect(() => {
        const timeOutChange = setTimeout(() => {
            setSearchValue(localValue)
        }, 300)

        return () => {
            timeOutChange && clearTimeout(timeOutChange)
        }
    }, [localValue])

    return (
        <div className="menu-wrapper-desk">
            <div className="menu-group-food-desk">
                <div className="container-fluid container-xl content">
                    <div className="head-avt-res-desk">
                        <img alt="banner" src={getFullFileUrl(logoPath)} />
                    </div>
                    <div
                        className={clsx(['food-search', searchOpen && 'open'])}
                    >
                        <div
                            className="btn-open"
                            onClick={() => setSearchOpen(true)}
                        >
                            <WrapIcon
                                size="18px"
                                icon={IconSearch}
                                color={searchOpen ? 'bdbdbd' : 'fff'}
                            />
                        </div>

                        {searchOpen && (
                            <>
                                <input
                                    autoFocus
                                    value={localValue}
                                    onChange={e =>
                                        setLocalValue(e.target.value)
                                    }
                                />

                                <div
                                    className="btn-close"
                                    onClick={handleCloseSearch}
                                >
                                    <WrapIcon
                                        size="12px"
                                        icon={IconClose}
                                        color="bdbdbd"
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    {!searchOpen && (
                        <>
                            <Swiper
                                className="group-list"
                                slidesPerView="auto"
                                onSwiper={swiper => {
                                    sliderRef.current = swiper
                                    swiper.on('slideChange', function () {
                                        setIsReachEnd(this.isEnd)
                                    })
                                    swiper.on('reachEnd', function () {
                                        setIsReachEnd(true)
                                    })
                                }}
                                realIndex={indexGroup}
                                ref={containerSliderRef}
                            >
                                {groups.map((group, i) => (
                                    <SwiperSlide
                                        className={clsx([
                                            'menu-item',
                                            (displayGroup === group.id || (displayGroup === -1 && !i)) &&
                                                'active',
                                        ])}
                                        onClick={() =>
                                            handleSetDisplayGroup(group.id)
                                        }
                                        key={group.id}
                                    >
                                        {group.name}
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <div
                                onClick={handleNext}
                                className={clsx([
                                    'btn-scroll-next',
                                    isReachEnd && 'disabled',
                                ])}
                            >
                                <i className="fas fa-chevron-right"></i>
                            </div>
                        </>
                    )}
                </div>
                <br />
            </div>
            <div className="divider">
                <div className="left" />
                <div className="right" />
            </div>
        </div>
    )
}

export default MenuDesktop
